import { Navigate, useRoutes } from 'react-router-dom';
// layouts

import { useAuth0 } from '@auth0/auth0-react';
import DashboardLayout from './layouts/dashboard';

import Orders from './pages/Orders';
import Login from './pages/Login';
import NotFound from './pages/Page404';
import Register from './pages/Register';
import OrderDetails from './pages/OrderDetails';
import SupplierReport from './pages/SupplierReport';
import SupplierList from './pages/SupplierList';
import ProductList from './pages/ProductList';
import ProductStockReport from './pages/ProductStockReport';
import StockReport from './pages/StockReport';
import UserList from './pages/UserList';
import AuthCheck from './components/AuthCheck';
import SupplierReportRedesigned from './pages/SupplierReportRedesigned';
import CustomerValidationReport from './pages/CustomerValidationReport';
import EmailSchedular from './pages/EmailSchedular';
import ManageExporters from './pages/ManageExporters';
import ManageImporters from './pages/ManageImporters';
import ManageExports from './pages/ManageExports';
import ManageImports from './pages/ManageImports';
import ManageExportsSupplier from './pages/ManageExportsSupplier';
import ManageImportsSupplier from './pages/ManageImportsSupplier';
import StockTransfers from './pages/StockTransfers';
import WarehouseList from './pages/WarehouseList';

export default function Router() {
  const { isAuthenticated, isLoading } = useAuth0();
  return useRoutes([
    {
      path: '/dashboard',
      element: <DashboardLayout />,
      children: [
        {
          path: 'users',
          element: (
            <AuthCheck
              isAuthenticated={isAuthenticated}
              isLoading={isLoading}
              children={<UserList />}
              navigateRoute={'/login'}
            />
          ),
        },
        {
          path: 'users/add',
          element: (
            <AuthCheck
              isAuthenticated={isAuthenticated}
              isLoading={isLoading}
              children={<Register />}
              navigateRoute={'/login'}
            />
          ),
        },
        {
          path: 'orders',
          element: (
            <AuthCheck
              isAuthenticated={isAuthenticated}
              isLoading={isLoading}
              children={<Orders />}
              navigateRoute={'/login'}
            />
          ),
        },
        // { path: 'supplier-report', element: <AuthCheck isAuthenticated={isAuthenticated} isLoading={isLoading} children={<SupplierReport/>} navigateRoute={"/login"}/>},
        {
          path: 'supplier-report',
          element: (
            <AuthCheck
              isAuthenticated={isAuthenticated}
              isLoading={isLoading}
              children={<SupplierReportRedesigned />}
              navigateRoute={'/login'}
            />
          ),
        },
        {
          path: 'customer-validation-report',
          element: (
            <AuthCheck
              isAuthenticated={isAuthenticated}
              isLoading={isLoading}
              children={<CustomerValidationReport />}
              navigateRoute={'/login'}
            />
          ),
        },
        {
          path: 'supplier-list',
          element: (
            <AuthCheck
              isAuthenticated={isAuthenticated}
              isLoading={isLoading}
              children={<SupplierList />}
              navigateRoute={'/login'}
            />
          ),
        },
        {
          path: 'product-list',
          element: (
            <AuthCheck
              isAuthenticated={isAuthenticated}
              isLoading={isLoading}
              children={<ProductList />}
              navigateRoute={'/login'}
            />
          ),
        },
        {
          path: 'stock-report',
          element: (
            <AuthCheck
              isAuthenticated={isAuthenticated}
              isLoading={isLoading}
              children={<StockReport />}
              navigateRoute={'/login'}
            />
          ),
        },
        {
          path: 'email-schedular',
          element: (
            <AuthCheck
              isAuthenticated={isAuthenticated}
              isLoading={isLoading}
              children={<EmailSchedular />}
              navigateRoute={'/login'}
            />
          ),
        },
        {
          path: 'stock-transfers',
          element: (
            <AuthCheck
              isAuthenticated={isAuthenticated}
              isLoading={isLoading}
              children={<StockTransfers />}
              navigateRoute={'/login'}
            />
          ),
        },
        {
          path: 'warehouse-list',
          element: (
            <AuthCheck
              isAuthenticated={isAuthenticated}
              isLoading={isLoading}
              children={<WarehouseList />}
              navigateRoute={'/login'}
            />
          ),
        },
        {
          path: 'warehouse-list',
          element: (
            <AuthCheck
              isAuthenticated={isAuthenticated}
              isLoading={isLoading}
              children={<WarehouseList />}
              navigateRoute={'/login'}
            />
          ),
        },
        {
          path: 'exporters',
          element: (
            <AuthCheck
              isAuthenticated={isAuthenticated}
              isLoading={isLoading}
              children={<ManageExporters />}
              navigateRoute={'/login'}
            />
          ),
        },
        {
          path: 'exports',
          element: (
            <AuthCheck
              isAuthenticated={isAuthenticated}
              isLoading={isLoading}
              children={<ManageExports />}
              navigateRoute={'/login'}
            />
          ),
        },
        {
          path: 'supplier-exports',
          element: (
            <AuthCheck
              isAuthenticated={isAuthenticated}
              isLoading={isLoading}
              children={<ManageExportsSupplier />}
              navigateRoute={'/login'}
            />
          ),
        },
        {
          path: 'import-locations',
          element: (
            <AuthCheck
              isAuthenticated={isAuthenticated}
              isLoading={isLoading}
              children={<ManageImporters />}
              navigateRoute={'/login'}
            />
          ),
        },
        {
          path: 'imports',
          element: (
            <AuthCheck
              isAuthenticated={isAuthenticated}
              isLoading={isLoading}
              children={<ManageImports />}
              navigateRoute={'/login'}
            />
          ),
        },
        {
          path: 'supplier-imports',
          element: (
            <AuthCheck
              isAuthenticated={isAuthenticated}
              isLoading={isLoading}
              children={<ManageImportsSupplier />}
              navigateRoute={'/login'}
            />
          ),
        },
        {
          path: 'product-list/stock/:id',
          element: (
            <AuthCheck
              isAuthenticated={isAuthenticated}
              isLoading={isLoading}
              children={<ProductStockReport />}
              navigateRoute={'/login'}
            />
          ),
        },
        {
          path: 'orders/:id',
          element: (
            <AuthCheck
              isAuthenticated={isAuthenticated}
              isLoading={isLoading}
              children={<OrderDetails />}
              navigateRoute={'/login'}
            />
          ),
        },
      ],
    },
    {
      path: '/',
      children: [
        { path: '', element: <Navigate to={isAuthenticated ? '/dashboard/orders' : '/login'} /> },
        { path: 'login', element: isAuthenticated ? <Navigate to="/dashboard/orders" /> : <Login /> },
        // { path: 'register', element: isAuthenticated ? <Navigate to="/dashboard/orders" /> : <Register /> },
        { path: '404', element: <NotFound /> },
        { path: '*', element: <Navigate to="/404" /> },
      ],
    },
    { path: '*', element: <Navigate to="/404" replace /> },
  ]);
}
